import passwordPolicy from '../passwordPolicy'

export const password = (value) => {
  const validatePassword = passwordPolicy.validatePassword(value)
  if (validatePassword instanceof Error) {
    return validatePassword.message
  }
}

export const passwordConfirmation = (value, form) => {
  const confirmationPassword = form.password
  if (confirmationPassword !== value) {
    return 'Passwords do not match'
  }
}

export const required = (value) => {
  return !value ? 'Field is required' : undefined
}



// WEBPACK FOOTER //
// ./src/validators/index.js